import trpc from "@/shared/utils/trpc";

const STORAGE_KEY = "gt_expo_profile_view_session";
const SESSION_KEY_RE = /^[a-zA-Z0-9_-]{8,80}$/;

function getExpoProfileViewSessionKey(): string {
  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);
    if (existing && SESSION_KEY_RE.test(existing)) return existing;
    const next = crypto.randomUUID().replace(/-/g, "");
    sessionStorage.setItem(STORAGE_KEY, next);
    return next;
  } catch {
    return "anonfallback";
  }
}

/** Fire-and-forget when the public expo profile page is shown (guest or signed-in). */
export function recordExpoProfileVisitBestEffort(expoSlug?: string | null): void {
  const slug = expoSlug?.trim();
  if (!slug) return;

  void trpc.discover.recordExpoProfileVisit
    .mutate({
      expoSlug: slug,
      sessionKey: getExpoProfileViewSessionKey(),
    })
    .catch(() => undefined);
}

/** Fire-and-forget when someone opens a company from an expo directory. */
export function recordExpoCompanyProfileViewBestEffort(args: {
  expoSlug?: string | null;
  companyId?: string | null;
}): void {
  const expoSlug = args.expoSlug?.trim();
  const companyId = args.companyId?.trim();
  if (!expoSlug || !companyId) return;

  void trpc.discover.recordExpoCompanyProfileView
    .mutate({
      expoSlug,
      companyId,
      sessionKey: getExpoProfileViewSessionKey(),
    })
    .catch(() => undefined);
}
